import React, {useEffect, useState ,useRef } from "react";
import MainLayout from "../../../commons/layout/MainLayout/index";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import { useNavigate, Link } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import {useSelector} from "react-redux";
import API, {ROUTES} from "../../../commons/api/api";
import DialogComponent from "../../../commons/components/Modal/DialogComponent";
import {checkImgUrl, formatPhoneNumber} from "../../../utils/helpers";
import { useDispatch } from "react-redux";
import {updateSuccess} from './../../Account/redux/actions/index'
import {put} from "redux-saga/effects";
import * as actionCreators from "../../Account/redux/actions";
import CountDownTime from "../../../commons/components/CountDownTime";

const Profile = () => {

    const { userInfo,type } = useSelector((state) => state.authReducers);

    const DEFAULT_IMAGE = '/images/album/img_myinfo@2x.png';

    const dispatch = useDispatch();

    const inputFile = useRef(null);

    const navigate = useNavigate();

    const handleLabelLeft = () => {
        console.log('handleLabelLeft');
        navigate(ROUTERS.HOME, {
            state: {
                menuStatus: true
            }
        })
    }

    const [dialogMessages, setDialogMessages] = useState({
        show : false,
        title : '',
        content : '',
    });

    const  [formData,setFormData] = useState({
        avatar : '',
        avatar_path : '',
        name : '',
        nickname : '',
        email : '',
        phone  : '',
        verify_code_phone_number : ''
    });

    const [error,setError] = useState({});


    // status : wait,waiting,done
    const [statusCheckPhoneNumber,setStatusCheckPhoneNumber] = useState('wait');

    const [statusCheckNickName,setStatusCheckNickName] = useState('wait'); //wait, done



    useEffect(() => {
        let avatar_path = '';
        if(userInfo.avatar){
            avatar_path = userInfo.avatar_url.thumbnail;
            if(checkImgUrl(userInfo.avatar)){
                avatar_path = userInfo.avatar
            }
        }

        if(userInfo){
            setFormData({
                ...formData,
                avatar_path : avatar_path,
                name : userInfo.fullname,
                nickname :userInfo.nickname,
                email : userInfo.email,
                phone  : userInfo.phone,
            })
        }
    },[userInfo])

    const initMinutes = 4;
    const initSecond = 59;

    const [ minutes, setMinutes ] = useState(initMinutes);
    const [seconds, setSeconds ] =  useState(initSecond);



    const handleChangeFormData = (event) => {

        const target = event.target;
        const  value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(name === 'avatar') {
            console.log(event.target.files,'da vo event');
            if(event.target.files && event.target.files.length){
                var file = event.target.files[0];

                var reader = new FileReader();
                var url = reader.readAsDataURL(file);

                reader.onloadend =  (e) => {
                    setFormData({
                        ...formData,
                        avatar_path: [reader.result],
                        avatar: file
                    })
                };

            }


            return false;
        }

        if(name === 'phone') {
            let valuePhoneNumber = value;
            valuePhoneNumber = value.replaceAll('-','')
            if(valuePhoneNumber.length <= 11) {
                const re = /^[0-9\b]+$/;
                if (valuePhoneNumber === '' || re.test(valuePhoneNumber)) {
                    setFormData({
                        ...formData,
                        [name]: formatPhoneNumber(valuePhoneNumber)
                    });
                    setStatusCheckPhoneNumber('wait');
                }
            }
            return false;
        }

        if(name === 'nickname'){
            setStatusCheckNickName('wait');
        }

        setFormData({
            ...formData,
            [name]: value
        })
    }

    const checkValidateNickName = () => {

        if(!formData.nickname){
            return setDialogMessages({
                ...dialogMessages,
                show : true,
                content: '닉네임은 필수 입력입니다.',
            })
        }

        if(formData.nickname === userInfo.nickname){
            return false;
        }

        API.post(ROUTES.API_CHECK_VALIDATE_USER,{type : 'nickname',value : formData.nickname}).then(res => {
            setDialogMessages({
                ...dialogMessages,
                show : true,
                content: '사용 가능한 닉네임입니다!',
            })
            setStatusCheckNickName('done');
        }).catch(e => {
            let error = e.response;
            let message = `<span class="text-danger">이미 존재하는 닉네임 입니다.</span>`

            if(error.status === 422 ){
                setDialogMessages({
                    ...dialogMessages,
                    show : true,
                    content: message,
                })
            }
        })
    }

    const checkSendCodePhoneNumber = () => {
        let phone_number = formData.phone;
        //start check send code
        API.post(`${ROUTES.API_SEND_CODE_PHONE_NUMBER}?type=sms`,{phone_number}).then(res => {
            setStatusCheckPhoneNumber('waiting');
            setMinutes(0);
            setSeconds(0);
            setMinutes(initMinutes);
            setSeconds(initSecond);
        });
    }

    const checkValidatePhone = () => {

        if(!formData.phone) {
            setDialogMessages({
                ...dialogMessages,
                show : true,
                content: `<span class="text-danger">전화번호를 입력해주세요.</span>`
            })
        }

        if(formData.phone === userInfo.phone){
            return false;
        }

        if(formData.phone){
            let phoneArr = formData.phone.split('-');
            if (phoneArr[0] !== '010') {
                return setDialogMessages({
                    show : true,
                    title : '알림',
                    content :'올바르지 않은 휴대폰 번호입니다.',
                    button : '확인',
                });
            }
        }

        setFormData({
            ...formData,
            verify_code_phone_number: ''
        })

        API.post(ROUTES.API_CHECK_VALIDATE_USER,{type : 'phone',value : formData.phone}).then(res => {
            checkSendCodePhoneNumber();
        }).catch(e => {
            let error = e.response;

            if(error.status === 422 ){
                let message = ``
                Object.keys(error.data.errors).map((item,index) => {

                    message = `<span class="text-danger">${error.data.errors[item][0]}</span>`;
                    if(error.data.errors[item][0] === '이미 등록된 핸드폰 번호입니다.'){
                        message = `<p class="text-danger p-0 m-0">이미 등록된 번호입니다.</p> <p class="text-danger p-0 m-0">번호를 다시 확인해주세요.</p>`;
                    }

                })
                setDialogMessages({
                    show : true,
                    title : '알림',
                    content :message,
                    button : '확인',
                })
            }
        })
    }

    const _handleCloseDialog = () => {
        setDialogMessages({
            ...dialogMessages,
            show : false
        })
    }

    const verifyCodePhoneNumber = () => {
        let  {verify_code_phone_number,phone} = formData;
        if(verify_code_phone_number){
            API.post(`${ROUTES.API_VERIFY_CODE_PHONE_NUMBER}?type=sms`,{phone_number : phone,code : verify_code_phone_number}).then(res => {
                // let message = `<p class="profile-page__email-text ">${phone}으로 </p>  회원가입을 진행하시겠습니까? <p class="profile-page__warning-text mt-2">! 등록된 전화번호는 변경할 수 없습니다.</p>`;
                let message = `휴대폰인증이 완료되었습니다.`;
                setDialogMessages({
                    show : true,
                    title : '알림',
                    content :message,
                    button : '확인',
                });

                setStatusCheckPhoneNumber('done');
                setMinutes(0)
                setSeconds(0)

            }).catch(e => {
                let message = '인증번호를\n' + '확인해주세요.\n';
                setDialogMessages({
                    show : true,
                    title : '알림',
                    content :message,
                    button : '확인',
                });
            })
        }
    }

    const onClickInputFile = (e) => {
        inputFile.current.click();
    };

    const handleSubmitForm = () => {
        console.log(statusCheckPhoneNumber, 'statusCheckPhoneNumberstatusCheckPhoneNumberstatusCheckPhoneNumber');
        var bodyFormData = new FormData();

        if(formData.phone){
            let phoneArr = formData.phone.split('-');
            if (phoneArr[0] !== '010') {
                return setDialogMessages({
                    show : true,
                    title : '알림',
                    content :'올바르지 않은 휴대폰 번호입니다.',
                    button : '확인',
                });
            }
        }


        if(formData.avatar){
            // bodyFormData.append("files", formData.avatar);
            bodyFormData.append("avatar", formData.avatar);
        }

        if(formData.phone && statusCheckPhoneNumber === 'done'){
            bodyFormData.append("phone", formData.phone);
        }

        if(formData.nickname && statusCheckNickName === 'done'){
            bodyFormData.append("nickname", formData.nickname);
        }

        if(formData.name && (formData.name != userInfo.fullname)){
            bodyFormData.append("name", formData.name);
        }

        if(statusCheckPhoneNumber === 'wait' && userInfo.phone !== formData.phone){
            return setDialogMessages({
                show : true,
                title : '알림',
                content :'휴대폰 인증이 필요합니다',
                button : '확인',
            });
        }

        if(statusCheckNickName === 'wait' && formData.nickname && formData.nickname != userInfo.nickname){
            return setDialogMessages({
                show : true,
                title : '알림',
                content :'닉네임 중복확인이 필요합니다.',
                button : '확인',
            });
        }

        if(statusCheckPhoneNumber === 'waiting'){
            return setDialogMessages({
                show : true,
                title : '알림',
                content :'인증번호를 확인해주세요.',
                button : '확인',
            });
        }

        API({
            method: "post",
            url: ROUTES.API_UPDATE_AUTH_ME,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(res => {
            let data = res.data.data;
            dispatch(updateSuccess(data));

            // let avatar_path = DEFAULT_IMAGE;
            // if(data.avatar){
            //     avatar_path = data.avatar_url.thumbnail;
            //     if(checkImgUrl(data.avatar)){
            //         avatar_path = data.avatar
            //     }
            // }
            //
            // setFormData({
            //     ...formData,
            //     avatar_path : avatar_path,
            //     name : data.fullname,
            //     nickname :data.nickname,
            //     email : data.email,
            //     phone  : data.phone,
            // });
            setStatusCheckNickName('wait');
            setStatusCheckPhoneNumber('wait');
            navigate(ROUTERS.HOME);
        }).catch(e => {
            let error =  e.response;
            let dataError = {};
            switch (error.status){
                case 422 :
                    if (error.data && error.data.errors) {
                        Object.keys(error.data.errors).map(function (key, index) {
                            dataError[key] = error.data.errors[key][0];
                        });
                        setError(dataError);
                    }
                    break;
            }
        })
    }

    let disabledButtonCheckValidate = false;

    if(statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0){
        disabledButtonCheckValidate = false;
    }else if (formData.phone === userInfo.phone || statusCheckPhoneNumber === 'waiting' || statusCheckPhoneNumber === 'done') {
        disabledButtonCheckValidate = true;
    }

    return (
        <MainLayout pageID={"profile-page"} displayBottomNav={false}>
            <HeaderHs2
                title={"내 정보"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={handleLabelLeft}
            />
            <div className="wrapper">
                <div className="row">
                    <div className="col-12  d-flex justify-content-center mt-3">
                        <div className="profile-page__avatar">
                            <img src={formData.avatar_path ? formData.avatar_path : DEFAULT_IMAGE} className="profile-page__avatar-image" alt="" />
                            <img
                                src="/images/album/icon_mypage_camera.svg"
                                className="profile-page__avatar-camera"
                                alt=""
                                onClick={onClickInputFile}
                            />
                            <input
                                type="file"
                                style={{display:'none'}}
                                name={'avatar'}
                                ref={inputFile}
                                onChange={handleChangeFormData}
                                multiple={false}
                                accept="image/*"
                            />
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <div className="input-component">
                            <label>이름</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    placeholder="이름을 입력하세요."
                                    value={formData.name ?? ''}
                                    onChange={handleChangeFormData}
                                    name={'name'}
                                />
                            </div>
                            {error.name ? <span className="input-error show">{error.name}</span> : ''}
                        </div>
                    </div>
                    <div className="col-12 mt-2">
                        <div className="input-component">
                            <label>닉네임</label>
                            <div className="input-group">
                                {/*form-control-error*/}
                                <input
                                    type="text"
                                    className="form-control  mr-2 profile-page__font-weight-500"
                                    value={formData.nickname ?? ''}
                                    onChange={handleChangeFormData}
                                    name={'nickname'}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-primary "
                                    onClick={checkValidateNickName}
                                    disabled={!formData.nickname || statusCheckNickName === 'done' || formData.nickname === userInfo.nickname ? true : false}
                                >중복확인</button>
                            </div>
                            {error.nickname ? <span className="input-error show">{error.nickname}</span> : ''}
                        </div>
                    </div>
                    <div className="col-12 mt-2">
                        <div className="input-component">
                            <label>이메일</label>
                            <div className="input-group d-flex justify-content-center align-items-center profile-page__input-group-custom">
                                <input
                                    type="text"
                                    className="form-control mr-2 profile-page__input-group-custom__input-disabled text-truncate"
                                    disabled
                                    value={formData.email ? formData.email.split('@')[0]  : ''}
                                />
                                <span className="mr-2">@</span>
                                <input
                                    type="text"
                                    className="form-control mr-2 profile-page__input-group-custom__input-disabled"
                                    disabled
                                    value={formData.email ? formData.email.split('@')[1]  : ''}
                                />
                                {/*                        <img src="/images/album/header_prev.svg" class="profile-page__input-group-custom__select-arrow" alt="">*/}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-2">
                        <div className="input-component  m-0 mb-2">
                            <label>휴대폰번호</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control mr-2 profile-page__font-weight-500"
                                    value={formData.phone ?? ''}
                                    onChange={handleChangeFormData}
                                    name={'phone'}
                                />
                                <button
                                    type="button"
                                    className="btn  btn-outline-primary profile-page__custom-button"
                                    onClick={checkValidatePhone}
                                    disabled={disabledButtonCheckValidate}
                                >{statusCheckPhoneNumber === 'wait' ? '인증' : '재발송'}</button>
                            </div>
                            {error.phone ? <span className="input-error show">{error.phone}</span> : ''}
                        </div>
                        {statusCheckPhoneNumber === 'waiting' || statusCheckPhoneNumber === 'done' ?  <div className="input-component">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control profile-page__input-time mr-2"
                                    placeholder="인증번호를 입력해주세요."
                                    name={'verify_code_phone_number'}
                                    onChange={handleChangeFormData}
                                    value={formData.verify_code_phone_number}
                                    disabled={statusCheckPhoneNumber === 'done' || (statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0 ) ? true : false}
                                />
                                <span className="profile-page__time">

                                    {statusCheckPhoneNumber === 'done' ? '' :  <CountDownTime
                                        minutes={minutes}
                                        seconds={seconds}
                                        setMinutes={setMinutes}
                                        setSeconds={setSeconds}
                                    />}

                                </span>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary profile-page__custom-button"
                                    onClick={verifyCodePhoneNumber}
                                    disabled={statusCheckPhoneNumber === 'done'  || (statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0) ? true : false}
                                >확인</button>
                            </div>
                            {/*                    <span class="input-error show">*비밀번호가 일치하지않습니다.</span>*/}
                        </div> : ''}
                    </div>
                    {localStorage.getItem('sns_type') == '' && <div className="col-12 mt-2">
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="profile-page__title-change-password">비밀번호 변경</p>
                                <p className="profile-page__detail-change-password">비밀번호 변경 페이지로 이동합니다.</p>
                            </div>
                            <button
                              type="button"
                              className="btn btn-outline-primary profile-page__custom-button"
                              onClick={()=>{
                                  navigate(ROUTERS.CHANGE_PASSWORD)
                              }}
                              disabled={localStorage.getItem('sns_type') ? true : false}
                            >변경하기</button>
                        </div>
                    </div>}

                    <div className="col-12 mt-5">
                        <button
                            type="button"
                            className="btn btn-block btn-primary"
                            onClick={handleSubmitForm}
                        >저장</button>
                    </div>
                </div>
            </div>
            {dialogMessages.show &&
                <DialogComponent
                    id={"MD3"}
                    show={dialogMessages.show}
                    title={"알림"}
                    closeBtn={"확인"}
                    handleClose={_handleCloseDialog}
                >
                    <div  className={'text-wrap'} dangerouslySetInnerHTML={{__html : dialogMessages.content}} />

                    {/*<p className={'p-0 m-0 mt-3 text-danger'}>{dialogMessages.warning || ''}</p>*/}
                </DialogComponent>}
        </MainLayout>
    )
}

export default Profile;
